// import React from "react";
// import "./OrderSection.scss";

// const OrderSection = () => {

//   return (
//     <section className="order-page-section">
//       <div className="search-input">
//         <h5 className="form-title">Order Management</h5>
//         <form action="">
//           <div className="input-wrap">
//             <img
//               src="/images/icons/search-icon-input.svg"
//               alt="search-icon-input"
//             />
//             <input
//               type="text"
//               placeholder="Search a order id, customer name, passenger name, email or phone."
//             />
//           </div>
//         </form>
//       </div>
//       <div className="table-responsive">
//         <table className="table table-striped order-info">
//           <thead className="table-dark">
//             <tr>
//               <th>Order ID</th>
//               <th>Order Type</th>
//               <th>Product</th>
//               <th>Customer Name</th>
//               <th>Phone</th>
//               <th>Email</th>
//               <th>Country</th>
//               <th>Paid Price (USD)</th>
//               <th>Revenue (USD)</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {[
//               {
//                 order_id: "10000019283321321",
//                 order_type: "Flights",
//                 product: "SIN to BKK (Round Trip)",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "100",
//                 revenue: "60.40",
//                 status: "Completed",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "Hotels",
//                 product: "Hotel Indigo Tokyo Shibuya",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "200",
//                 revenue: "60.40",
//                 status: "Completed",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "eSim",
//                 product: "Global 10GB 30 Days",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "4,000",
//                 revenue: "60.40",
//                 status: "Cancelled",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "Tours",
//                 product: "Bus Tour Singapore",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "4,000",
//                 revenue: "60.40",
//                 status: "Refunded",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "attractions",
//                 product: "Tokyo Dome City Attraction Ticket",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "4,000",
//                 revenue: "60.40",
//                 status: "Failed",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "Experience",
//                 product: "Gyeongju Hanbok Experience",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "4,000",
//                 revenue: "60.40",
//                 status: "Failed",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 order_id: "10000019283321321",
//                 order_type: "Airport Transfer",
//                 product: "HND Airport to Hotel Indigo Tokyo Shibuya (Pick Up)",
//                 name: "Tan Ah Lim",
//                 phone: "900017788",
//                 email: "ahlim@gmail.com",
//                 country: "Singapore",
//                 paid: "4,000",
//                 revenue: "60.40",
//                 status: "Failed",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//             ].map((row, i) => (
//               <tr key={i}>
//                 <td>{row.order_id}</td>
//                 <td>{row.order_type}</td>
//                 <td>{row.product}</td>
//                 <td>{row.name}</td>
//                 <td>{row.phone}</td>
//                 <td>{row.email}</td>
//                 <td>{row.country}</td>
//                 <td>{row.paid}</td>
//                 <td>{row.revenue}</td>
//                 <td>{row.status}</td>
//                 <td>
//                   <span
//                     data-bs-toggle="modal"
//                     data-bs-target="#orderManagementModal"
//                   >
//                     {row.action} {row.img}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div
//         className="modal fade"
//         id="orderManagementModal"
//         tabIndex="-1"
//         aria-labelledby="orderManagementModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content orderManagement-modal">
//             <div className="modal-body">
//               <div className="modal-header">
//                 <h5 className="modal-title">User Details</h5>
//                 <img
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                   src="/images/icons/close-circle.svg"
//                   alt="close-circle"
//                 />
//               </div>
//               <div className="order-detail-wrapper">
//                 {/* Bootstrap Nav Tabs */}
//                 <div className="d-flex mb-3 flex-wrap gap-2 align-items-center justify-content-between">
//                   <ul
//                     className="nav nav-tabs order-detail"
//                     id="myTab"
//                     role="tablist"
//                   >
//                     <li className="nav-item" role="presentation">
//                       <button
//                         className="nav-link active"
//                         id="orderInfo-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#orderInfo"
//                         type="button"
//                         role="tab"
//                         aria-controls="orderInfo"
//                         aria-selected="false"
//                       >
//                         Order Information
//                       </button>
//                     </li>
//                     <li className="nav-item" role="presentation">
//                       <button
//                         className="nav-link"
//                         id="deviceInfo-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#deviceInfo"
//                         type="button"
//                         role="tab"
//                         aria-controls="deviceInfo"
//                         aria-selected="true"
//                       >
//                         Device Information
//                       </button>
//                     </li>
//                   </ul>
//                   <img
//                     src="/images/icons/dot-btn.svg"
//                     data-bs-toggle="modal"
//                     data-bs-target="#cancelModal"
//                     alt="dot-btn"
//                   />
//                 </div>

//                 {/* Tab Content */}
//                 <div className="tab-content" id="myTabContent">
//                   <div
//                     className="tab-pane fade show active"
//                     id="orderInfo"
//                     role="tabpanel"
//                     aria-labelledby="orderInfo-tab"
//                   >
//                     <div className="details">
//                       <div className="row">
//                         <div className="col-12 col-md-6">
//                           <p>
//                             <strong>Order ID</strong> 10000019283321321
//                           </p>
//                           <p>
//                             <strong>Product</strong> SIN - BYK (Round Trip)
//                           </p>
//                           <p>
//                             <strong>Customer Full Name</strong> Ah Lim Tan
//                           </p>
//                           <p>
//                             <strong>Customer Phone</strong> 12313476585679
//                           </p>
//                           <p>
//                             <strong>Paid Price (USD)</strong> $240
//                           </p>
//                           <p>
//                             <strong>Payment Method</strong> Apple Pay
//                           </p>
//                         </div>
//                         <div className="col-12 col-md-6">
//                           <p>
//                             <strong>Order Type</strong> Flights
//                           </p>
//                           <p>
//                             <strong>Status</strong> Completed
//                           </p>
//                           <p>
//                             <strong>Customer Email</strong> ahlimtan@gmail.com
//                           </p>
//                           <p>
//                             <strong>Customer Country</strong> Singapore
//                           </p>
//                           <p>
//                             <strong>Revenue (USD)</strong> $40.66
//                           </p>
//                         </div>
//                         <hr />
//                         <strong className="mb-3">Flights Information</strong>
//                         <div className="row">
//                           <div className="col-12 col-md-6">
//                             <p>
//                               <strong>Passenger 1 First Name</strong> Ah Lim
//                             </p>
//                             <p>
//                               <strong>Airline</strong> Singapore Airline
//                             </p>
//                             <p>
//                               <strong>Departing</strong> Singapore
//                             </p>
//                             <p>
//                               <strong>Departing Date Time</strong> 02, JUN, 2025
//                               - 04:00 Hours
//                             </p>
//                             <p>
//                               <strong>Arriving Airport</strong> Haneda Airport
//                             </p>
//                             <p>
//                               <strong>Class</strong> Economy
//                             </p>
//                           </div>
//                           <div className="col-12 col-md-6">
//                             <p>
//                               <strong>Passenger 1 Last Name</strong> Tan
//                             </p>
//                             <p>
//                               <strong>Flight</strong> SQI
//                             </p>
//                             <p>
//                               <strong>Departing Airport</strong> Changi Airport
//                             </p>
//                             <p>
//                               <strong>Arriving</strong> Tokyo
//                             </p>
//                             <p>
//                               <strong>Arriving Date Time</strong> 02, JUN, 2025
//                               - 04:00 Hours
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     className="tab-pane fade"
//                     id="deviceInfo"
//                     role="tabpanel"
//                     aria-labelledby="deviceInfo-tab"
//                   >
//                     <div className="details">
//                       <div className="row">
//                         <div className="col-12 col-md-6">
//                           <p>
//                             <strong>Booking IP Address</strong> 192.890.1.1
//                           </p>
//                           <p>
//                             <strong>IP Address ISP</strong> Singtel
//                           </p>
//                         </div>
//                         <div className="col-12 col-md-6">
//                           <p>
//                             <strong>Geolocation (Latitude-Longitude)</strong>{" "}
//                             1.234567, 103.8518895
//                           </p>
//                           <p>
//                             <strong>Device Information</strong> iPhone 20 Pro
//                             Max
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div
//         className="modal fade"
//         id="cancelModal"
//         tabIndex="-1"
//         aria-labelledby="cancelModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content cancel-modal">
//             <div className="modal-body">
//               <h5 className="modal-title">Cancel & Refund</h5>
//               <p>
//                 Are you sure you want to cancel this order and initiate refund.
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 Cancel
//               </button>
//               <button type="button" className="btn">
//                 Cancel & Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OrderSection;
// import React, { useEffect, useState } from "react";
// import "./OrderSection.scss";
// import { getOrders } from "../../../../requests/ordersAPI";

// const OrderSection = () => {
//   const [orders, setOrders] = useState([]);
//   const [search, setSearch] = useState("");

//   const fetchOrders = async (query = "") => {
//     try {
//       const res = await getOrders(query);
//       console.log(res);

//       if (res) {
//         setOrders(res);
//       }
//     } catch (err) {
//       console.error("Error fetching orders:", err);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchOrders(search);
//   };

//   return (
//     <section className="order-page-section">
//       <div className="search-input">
//         <h5 className="form-title">Order Management</h5>
//         <form onSubmit={handleSearch}>
//           <div className="input-wrap">
//             <img
//               src="/images/icons/search-icon-input.svg"
//               alt="search-icon-input"
//             />
//             <input
//               type="text"
//               placeholder="Search a order id, customer name, passenger name, email or phone."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>
//         </form>
//       </div>
//       <div className="table-responsive">
//         <table className="table table-striped order-info">
//           <thead className="table-dark">
//             <tr>
//               <th>Order ID</th>
//               <th>Order Type</th>
//               <th>Product</th>
//               <th>Customer Name</th>
//               <th>Phone</th>
//               <th>Email</th>
//               <th>Country</th>
//               <th>Paid Price </th>
//               <th>Revenue </th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orders.length > 0 ? (
//               orders?.map((row, i) => (
//                 <tr key={i}>
//                   <td>{row.TeleportOrder}</td>
//                   <td>eSim</td>
//                   <td>{row.name}</td>
//                   <td>{row.user?.fullName}</td>
//                   <td>{row.user?.phone}</td>
//                   <td>{row.user?.email}</td>
//                   <td>{row.user?.country}</td>
//                   <td>{(row.price / 10000).toFixed(2)}</td>
//                   <td>
//                     {(row.price / 10000 - row.retailPrice / 10000).toFixed(2) +
//                       " " +
//                       row?.currencyCode}
//                   </td>
//                   <td>{row.isCancelled ? "Cancelled" : "Completed"}</td>
//                   <td>
//                     <span
//                       data-bs-toggle="modal"
//                       data-bs-target="#orderManagementModal"
//                     >
//                       More Details{" "}
//                       <img
//                         src="/images/icons/detail-arrow.svg"
//                         alt="detail-arrow"
//                       />
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">
//                   No orders found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Keep your modal code unchanged */}
//       <div
//         className="modal fade"
//         id="orderManagementModal"
//         tabIndex="-1"
//         aria-labelledby="orderManagementModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content orderManagement-modal">
//             <div className="modal-body">
//               <div className="modal-header">
//                 <h5 className="modal-title">User Details</h5>
//                 <img
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                   src="/images/icons/close-circle.svg"
//                   alt="close-circle"
//                 />
//               </div>
//               {/* your modal details remain here */}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className="modal fade"
//         id="cancelModal"
//         tabIndex="-1"
//         aria-labelledby="cancelModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content cancel-modal">
//             <div className="modal-body">
//               <h5 className="modal-title">Cancel & Refund</h5>
//               <p>
//                 Are you sure you want to cancel this order and initiate refund.
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 Cancel
//               </button>
//               <button type="button" className="btn">
//                 Cancel & Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OrderSection;
import React, { useEffect, useState } from "react";
import "./OrderSection.scss";
import { getOrders } from "../../../../requests/ordersAPI";

const OrderSection = () => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null); // ✅ new state

  const fetchOrders = async (query = "") => {
    try {
      const res = await getOrders(query);
      if (res) {
        setOrders(res);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchOrders(search);
  };

  return (
    <section className="order-page-section">
      <div className="search-input">
        <h5 className="form-title">Order Management</h5>
        <form onSubmit={handleSearch}>
          <div className="input-wrap">
            <img
              src="/images/icons/search-icon-input.svg"
              alt="search-icon-input"
            />
            <input
              type="text"
              placeholder="Search a order id, customer name, passenger name, email or phone."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </form>
      </div>
      <div className="table-responsive">
        <table className="table table-striped order-info">
          <thead className="table-dark">
            <tr>
              <th>Order ID</th>
              <th>Order Type</th>
              <th>Product</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Country</th>
              <th>Paid Price </th>
              <th>Revenue </th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders?.map((row, i) => (
                <tr key={i}>
                  <td>{row.TeleportOrder}</td>
                  <td>eSim</td>
                  <td>{row.name}</td>
                  <td>{row.user?.fullName}</td>
                  <td>{row.user?.phone}</td>
                  <td>{row.user?.email}</td>
                  <td>{row.user?.country}</td>
                  <td>{(row.price / 10000).toFixed(2)}</td>
                  <td>
                    {(row.price / 10000 - row.retailPrice / 10000).toFixed(2) +
                      " " +
                      row?.currencyCode}
                  </td>
                  <td>{row.isCancelled ? "Cancelled" : "Completed"}</td>
                  <td>
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#orderManagementModal"
                      onClick={() => setSelectedOrder(row)} // ✅ set clicked order
                      style={{ cursor: "pointer" }}
                    >
                      More Details{" "}
                      <img
                        src="/images/icons/detail-arrow.svg"
                        alt="detail-arrow"
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center">
                  No orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Order Details Modal */}
      {/* <div
        className="modal fade"
        id="orderManagementModal"
        tabIndex="-1"
        aria-labelledby="orderManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content orderManagement-modal">
            <div className="modal-header">
              <h5 className="modal-title">Order Details</h5>
              <img
                data-bs-dismiss="modal"
                aria-label="Close"
                src="/images/icons/close-circle.svg"
                alt="close-circle"
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className="modal-body">
              {selectedOrder ? (
                <div className="order-details">
                  <p>
                    <strong>Order ID:</strong> {selectedOrder.TeleportOrder}
                  </p>
                  <p>
                    <strong>Order Type:</strong> eSim
                  </p>
                  <p>
                    <strong>Product:</strong> {selectedOrder.name}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {selectedOrder.isCancelled ? "Cancelled" : "Completed"}
                  </p>

                  <hr />

                  <h6>Customer Info</h6>
                  <p>
                    <strong>Name:</strong> {selectedOrder.user?.fullName}
                  </p>
                  <p>
                    <strong>Email:</strong> {selectedOrder.user?.email}
                  </p>
                  <p>
                    <strong>Phone:</strong> {selectedOrder.user?.phone}
                  </p>
                  <p>
                    <strong>Country:</strong> {selectedOrder.user?.country}
                  </p>

                  <hr />

                  <h6>Payment Info</h6>
                  <p>
                    <strong>Paid Price:</strong>{" "}
                    {(selectedOrder.price / 10000).toFixed(2)}{" "}
                    {selectedOrder.currencyCode}
                  </p>
                  <p>
                    <strong>Retail Price:</strong>{" "}
                    {(selectedOrder.retailPrice / 10000).toFixed(2)}{" "}
                    {selectedOrder.currencyCode}
                  </p>
                  <p>
                    <strong>Revenue:</strong>{" "}
                    {(
                      selectedOrder.price / 10000 -
                      selectedOrder.retailPrice / 10000
                    ).toFixed(2)}{" "}
                    {selectedOrder.currencyCode}
                  </p>
                </div>
              ) : (
                <p>No order selected</p>
              )}
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="modal fade"
        id="orderManagementModal"
        tabIndex="-1"
        aria-labelledby="orderManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content orderManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">User Details</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>

              <div className="order-detail-wrapper">
                {/* Tabs */}
                <div className="d-flex mb-3 flex-wrap gap-2 align-items-center justify-content-between">
                  <ul
                    className="nav nav-tabs order-detail"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="orderInfo-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#orderInfo"
                        type="button"
                        role="tab"
                        aria-controls="orderInfo"
                        aria-selected="true"
                      >
                        Order Information
                      </button>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="deviceInfo-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#deviceInfo"
                        type="button"
                        role="tab"
                        aria-controls="deviceInfo"
                        aria-selected="false"
                      >
                        Device Information
                      </button>
                    </li> */}
                  </ul>
                  {/* <img
                    src="/images/icons/dot-btn.svg"
                    data-bs-toggle="modal"
                    data-bs-target="#cancelModal"
                    alt="dot-btn"
                  /> */}
                </div>

                {/* Tab Content */}
                <div className="tab-content" id="myTabContent">
                  {/* --- Order Info Tab --- */}
                  <div
                    className="tab-pane fade show active"
                    id="orderInfo"
                    role="tabpanel"
                    aria-labelledby="orderInfo-tab"
                  >
                    {selectedOrder ? (
                      <div className="details">
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <p>
                              <strong>Order ID</strong>{" "}
                              {selectedOrder.TeleportOrder}
                            </p>
                            <p>
                              <strong>Product</strong> {selectedOrder.name}
                            </p>
                            <p>
                              <strong>Customer Full Name</strong>{" "}
                              {selectedOrder.user?.fullName}
                            </p>
                            <p>
                              <strong>Customer Phone</strong>{" "}
                              {selectedOrder.user?.phone}
                            </p>
                            <p>
                              <strong>
                                Paid Price ({selectedOrder.currencyCode})
                              </strong>{" "}
                              {(selectedOrder.price / 10000).toFixed(2)}
                            </p>
                            <p>
                              <strong>Payment Method</strong>{" "}
                              {selectedOrder.paymentMethod || "N/A"}
                            </p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p>
                              <strong>Order Type</strong> eSim
                            </p>
                            <p>
                              <strong>Status</strong>{" "}
                              {selectedOrder.isCancelled
                                ? "Cancelled"
                                : "Completed"}
                            </p>
                            <p>
                              <strong>Customer Email</strong>{" "}
                              {selectedOrder.user?.email}
                            </p>
                            <p>
                              <strong>Customer Country</strong>{" "}
                              {selectedOrder.user?.country}
                            </p>
                            <p>
                              <strong>
                                Revenue ({selectedOrder.currencyCode})
                              </strong>{" "}
                              {(
                                selectedOrder.price / 10000 -
                                selectedOrder.retailPrice / 10000
                              ).toFixed(2)}
                            </p>
                          </div>
                        </div>

                        {/* <hr />
                        <strong className="mb-3">Flights Information</strong> */}
                        {/* {selectedOrder.flight ? (
                          <div className="row">
                            <div className="col-12 col-md-6">
                              <p>
                                <strong>Passenger First Name</strong>{" "}
                                {selectedOrder.flight.passengerFirstName}
                              </p>
                              <p>
                                <strong>Airline</strong>{" "}
                                {selectedOrder.flight.airline}
                              </p>
                              <p>
                                <strong>Departing</strong>{" "}
                                {selectedOrder.flight.departureCity}
                              </p>
                              <p>
                                <strong>Departing Date Time</strong>{" "}
                                {selectedOrder.flight.departureTime}
                              </p>
                              <p>
                                <strong>Arriving Airport</strong>{" "}
                                {selectedOrder.flight.arrivalAirport}
                              </p>
                              <p>
                                <strong>Class</strong>{" "}
                                {selectedOrder.flight.class}
                              </p>
                            </div>
                            <div className="col-12 col-md-6">
                              <p>
                                <strong>Passenger Last Name</strong>{" "}
                                {selectedOrder.flight.passengerLastName}
                              </p>
                              <p>
                                <strong>Flight</strong>{" "}
                                {selectedOrder.flight.flightNumber}
                              </p>
                              <p>
                                <strong>Departing Airport</strong>{" "}
                                {selectedOrder.flight.departureAirport}
                              </p>
                              <p>
                                <strong>Arriving</strong>{" "}
                                {selectedOrder.flight.arrivalCity}
                              </p>
                              <p>
                                <strong>Arriving Date Time</strong>{" "}
                                {selectedOrder.flight.arrivalTime}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <p>No flight information available</p>
                        )} */}
                      </div>
                    ) : (
                      <p>No order selected</p>
                    )}
                  </div>

                  {/* --- Device Info Tab --- */}
                  {/* <div
                    className="tab-pane fade"
                    id="deviceInfo"
                    role="tabpanel"
                    aria-labelledby="deviceInfo-tab"
                  >
                    {selectedOrder?.deviceInfo ? (
                      <div className="details">
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <p>
                              <strong>Booking IP Address</strong>{" "}
                              {selectedOrder.deviceInfo.ip}
                            </p>
                            <p>
                              <strong>IP Address ISP</strong>{" "}
                              {selectedOrder.deviceInfo.isp}
                            </p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p>
                              <strong>Geolocation (Lat-Long)</strong>{" "}
                              {selectedOrder.deviceInfo.lat},{" "}
                              {selectedOrder.deviceInfo.long}
                            </p>
                            <p>
                              <strong>Device Information</strong>{" "}
                              {selectedOrder.deviceInfo.device}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p>No device info available</p>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cancel Modal */}
      {/* <div
        className="modal fade"
        id="cancelModal"
        tabIndex="-1"
        aria-labelledby="cancelModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content cancel-modal">
            <div className="modal-body">
              <h5 className="modal-title">Cancel & Refund</h5>
              <p>
                Are you sure you want to cancel this order and initiate refund?
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button type="button" className="btn">
                Cancel & Refund
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default OrderSection;
